@if (withDragAndDrop()) {
    <div
        class="dropzone"
        qpxDnd
        [disabled]="isDisabled()"
        [qpxDropSurface]="dropAppearance()"
        [attr.aria-busy]="isProcessing()"
        role="group"
        aria-label="File upload drop target"
        (dropped)="onDrop($event)"
    >
        <div class="drop-status" role="status">
            @if (isProcessing()) {
                <qpx-loader
                    containerClass="flex items-center justify-center"
                    size="sm"
                    ariaLabel="Preparing files"
                />
            } @else {
                <qpx-hero-icon
                    [active]="true"
                    [context]="dropContext()"
                    [name]="dropIcon()"
                />
            }
            <div class="drop-copy">
                <p class="dropzone-label text-body-lg font-semibold">
                    {{ dropLabel() }}
                </p>
                @if (dropAppearance().state === 'invalid') {
                    <p class="dropzone-label text-body-md">{{ dropIssue() }}</p>
                }
            </div>
        </div>
        <ng-container *ngTemplateOutlet="defaultTpl" />
        <div class="drop-help"><ng-content /></div>
    </div>
} @else {
    <ng-container *ngTemplateOutlet="defaultTpl" />
}

<ng-template #defaultTpl>
    <div class="picker-actions">
        <input
            #fileInput
            type="file"
            class="hidden-input"
            tabindex="-1"
            [accept]="acceptedFileTypes()"
            [id]="ids().fileInput"
            [attr.aria-label]="ariaLabels().file"
            [disabled]="isDisabled()"
            [attr.multiple]="multiple() ? '' : null"
            (change)="onBrowse($event)"
        />

        @if (filePickerTpl(); as tplFilePicker) {
            <ng-container
                [ngTemplateOutlet]="tplFilePicker"
                [ngTemplateOutletContext]="customFilePickerContext()"
            />
        } @else {
            <button
                qpxButton
                matButton="outlined"
                [size]="buttonSize()"
                [disabled]="isDisabled()"
                (click)="fileInput.click()"
                [attr.aria-controls]="ids().fileInput"
            >
                <ng-icon
                    qpx
                    [size]="fileIcon().size"
                    [context]="fileIcon().context"
                    [set]="fileIcon().set"
                    [type]="fileIcon().type"
                    [name]="fileIcon().icon"
                    matButtonIcon
                />
                <span>{{ fileLabel() }}</span>
            </button>
        }

        @if (allowFolderSelection()) {
            <input
                #folderInput
                type="file"
                class="hidden-input"
                tabindex="-1"
                [id]="ids().folderInput"
                [attr.aria-label]="ariaLabels().folder"
                [disabled]="isDisabled()"
                webkitdirectory
                directory
                (change)="onBrowse($event)"
            />

            @if (folderPickerTpl(); as tplFolderPicker) {
                <ng-container
                    [ngTemplateOutlet]="tplFolderPicker"
                    [ngTemplateOutletContext]="customFolderPickerContext()"
                />
            } @else {
                <button
                    qpxButton
                    matButton="outlined"
                    [size]="buttonSize()"
                    [disabled]="isDisabled()"
                    (click)="folderInput.click()"
                    [attr.aria-controls]="ids().folderInput"
                >
                    <ng-icon
                        qpx
                        [size]="folderIcon().size"
                        [context]="folderIcon().context"
                        [set]="folderIcon().set"
                        [type]="folderIcon().type"
                        [name]="folderIcon().icon"
                        matButtonIcon
                    />
                    <span>{{ folderLabel() }}</span>
                </button>
            }
        }
    </div>
</ng-template>
